angular.module('note')
    .component('dashboardNoteItem', {
        bindings: {
            item: '<'
        },
        template: `
            <div class="dashboard-task-container">
                <div class="info">
                    <div class="user-thumb">
                        <user-avatar user="$ctrl.item.audit.createdBy" size="34" font-size="16"></user-avatar>
                    </div>
                    <div class="task-header">
                        <div class="wrap-long-line">
                            <client-list-format clients="$ctrl.item.clients" show-all="false"></client-list-format>
                            <a href="#/notes/{{$ctrl.item.id}}">{{$ctrl.item.topic}}</a>
                            <span style="font-size: smaller;" ng-if="($ctrl.item.audit.createdTime | date:'yyyy-MM-dd') != $ctrl.item.dateOfIssue" title="Data notatki">({{$ctrl.item.dateOfIssue}})</span>
                        </div>
                        <div class="task-most-important">
                            <span class="activity-time">
                                <abbr title="{{$ctrl.item.audit.createdTime | date : 'medium'}}" am-time-ago="$ctrl.item.audit.createdTime"></abbr>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="actions">
                    <div class="task-icons">
                        <document-private-ico private="$ctrl.item.private" title="Notatka widoczna tylko dla Ciebie!"></document-private-ico>
                        <document-comments-count document="$ctrl.item"></document-comments-count>
                        <document-files-count document="$ctrl.item"></document-files-count>
                        <document-priority-star priority="$ctrl.item.priority"></document-priority-star>
                    </div>
                    <div class="dashboard-task-actions">
                        <note-btn-options item="$ctrl.item" large-button="false"></note-btn-options>
                    </div>
                </div>
            </div>
        `
    })
